import app from '@/main';

export default {
  async init({ commit }) {
    await commit('setIsInitialized', true);
    await commit('setIsAppLoading', false);
  },
  async checkMaintenanceMode({ commit }) {
    await app.$remoteConfig
      .fetchAndActivate()
      .then(() => {
        commit(
          'setMaintenanceModeActive',
          app.$remoteConfig.getBoolean('maintenanceModeActive')
        );
        commit(
          'setMaintenanceModeContent',
          app.$remoteConfig.getString('maintenanceModeContent')
        );
        commit(
          'setMaintenanceModeOnlyProduction',
          app.$remoteConfig.getBoolean('maintenanceModeOnlyProduction')
        );
      })
      .catch(e => e);
  },
  async setCheckMaintenanceModeInterval({ dispatch }) {
    setInterval(() => {
      dispatch('checkMaintenanceMode');
    }, process.env.VUE_APP_FIREBASE_REMOTE_CONFIG_INTERVAL_MS);
  },
  async waiter(context, { ms = 0 }) {
    await new Promise(resolve =>
      setTimeout(() => {
        resolve();
      }, ms)
    );
  },
};
